import BuildingSecondaryNavbar from './site-management/Buildings.vue'
import {routers as BuildingSecondaryNavbarChildren} from './site-management/Buildings'

let routers = [
  {
    name: 'show-building-navbar',
    path: 'show-building-navbar',
    component: BuildingSecondaryNavbar,
    children: BuildingSecondaryNavbarChildren,
    redirect: {
      name: 'list-buildings'
    }
  },
]

export { routers }